import "./scss/index.scss";
import React from "react";
import email from "../../../images/email.svg";
import phone from "../../../images/phone.svg";
import { linkResolver } from "../../prismic-config";
export function ContactsNav(_ref) {
  var contact = _ref.contact;
  var contactsList = contact === null || contact === void 0 ? void 0 : contact.filter(function (z) {
    return z.show_in_nav;
  });
  return React.createElement("div", {
    className: "nav-contacts"
  }, contactsList === null || contactsList === void 0 ? void 0 : contactsList.map(function (c, i) {
    return React.createElement("div", {
      className: "nav-contacts__item",
      key: i
    }, c.type === "phone" && React.createElement("img", {
      src: phone,
      width: "16px",
      height: "16px",
      alt: "phone"
    }), c.type === "email" && React.createElement("img", {
      src: email,
      width: "16px",
      height: "16px",
      alt: "email"
    }), React.createElement("a", {
      href: linkResolver(c.link),
      className: "nav-contacts__text"
    }, c.label));
  }));
}